/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-var: 0 */
/* globals _, Highcharts, mp */

_.namespace(`mp.marketing.trends.reports`, function(ns) {
  'use strict';

  ns.AndroidVsIOS = mp.marketing.trends.widgets.TrendReport.extend({
    get_queries() {
      var date_range = this.session.get(`date_range`);
      return {
        base: {
          'query_name': `android_vs_ios`,
          'from_date': date_range.from().toString(mp.utility.default_date_format),
          'to_date': date_range.to().toString(mp.utility.default_date_format),
        },
      };
    },

    get_chart_params(query_data) {
      var date_totals = {};
      _.each(query_data.base, function(dates) {
        _.each(dates, function(val, date) {
          if (_.has(date_totals, date)) { date_totals[date] += val; }
          else { date_totals[date] = val; }
        });
      });

      var produce_series = function(data) {
        return _(data).chain().
          map(function(val, date) {
            var unixtime = Date.parseExact(date, `yyyy-MM-dd`).getTime(),
              percent = (val / date_totals[date]) * 100;
            return [unixtime, percent ? percent : 0];
          }).
          sortBy(function(s) { return s[0]; }).
          value();
      };

      var chart_data = [
        {
          'name': `iPhone`,
          'data': produce_series(query_data.base[`true`]),
          'color': mp.charts.nth_color(0),
        },
        {
          'name': `Android`,
          'data': produce_series(query_data.base[`false`]),
          'color': mp.charts.nth_color(1),
        },
      ];

      return {
        'xAxis': {
          'labels': {
            'formatter'() {
              return Highcharts.dateFormat(`%b. %e`, this.value);
            },
          },
          'type': `datetime`,
        },
        'yAxis': {'labels': {'formatter'() { return this.value + `%`; }}},
        'series': chart_data,
        'tooltip': {
          'shared': true,
          'crosshairs': true,
          'backgroundColor': `rgba(255, 255, 255, 1)`,
          'borderWidth': 1,
          'useHTML': false,
          'pointFormat': `<span style="color:{series.color}">{series.name}</span>: <b>{point.y}%</b><br/>`,
          'valueDecimals': 2,
        },
      };
    },

    getDownloadName() {
      return ns.AndroidVsIOS.nice_name;
    },
  });

  // used by the data_viewer to render pretty dropdowns and stuff
  ns.AndroidVsIOS.slug = `android_vs_ios`;
  ns.AndroidVsIOS.nice_name = `Android vs. iOS`;
  ns.AndroidVsIOS.description = `How do activity levels on Android and iOS compare? Are they changing over time?`;
  ns.AndroidVsIOS.chart_type = `line`;
});

}.call(window));